<template>
  <proofreading-select-checks slot="main" :novel-id="novelId" />
</template>

<script lang="ts">
import Vue from "vue";
import ProofreadingSelectChecks from "@/components/organisms/proofreading/ProofreadingSelectChecks.vue";

export default Vue.extend({
  metaInfo: {
    meta: [{ name: "robots", content: "none" }],
  },
  components: { ProofreadingSelectChecks },
  props: {
    novelId: String,
  },
});
</script>
